import React, { useEffect, useRef, useState } from 'react';
import { ArrowUpRightIcon, HeartIcon } from '../assets/icons/Icons';
import '../styles/doctors.css';

const doctorsData = [
  {
    photo: '/doctors/rishika.jpg',
    avatarClass: 'd1',
    name: 'Dr. Sai Rishika P',
    spec: 'Psychiatry & De-addiction',
    exp: '3 years experience',
    tags: ['Anxiety', 'Depression', 'Addiction'],
    fee: '₹1,500',
    bookingUrl: 'https://book.healthplix.com/dr-doctor-s-name-specialisation-place-city_198213',
    bio: [
      'Dr. Sai Rishika is a psychiatrist and co-founder of Ishira The Mind Clinic. She completed her postgraduate training and subsequently pursued a postdoctoral fellowship in Addiction Medicine at the National Institute of Mental Health and Neurosciences (NIMHANS, Bengaluru). She has expertise in the management of addictive disorders, including behavioural addictions, and has special interests in adolescent and women’s mental health.',
      'She has received training in psychotherapy and transcranial brain stimulation for behavioural addictions, and has also undergone specialized training in Motivational Interviewing under William R. Miller. In addition, she has been involved in training programs for tobacco counsellors and has participated in television broadcasts focused on tobacco cessation awareness.',
      'Dr. Sai Rishika is passionate about reducing mental health stigma and believes in providing compassionate, inclusive, and evidence-based care tailored to the unique needs of each individual. Through her work at Ishira, she strives to create a safe and supportive space where people feel heard, understood, and empowered in their mental health journey.',
      'Languages: English, Hindi, Kannada, Telugu, Tamil',
    ],
  },
  {
    photo: '/doctors/patachara1.jpg',
    avatarClass: 'd2',
    name: 'Ms. Patachara',
    spec: 'Clinical Psychology',
    exp: '4 years experience',
    tags: ['Couple & Family', 'Trauma Therapy', 'CBT'],
    fee: '₹2,000',
    bookingUrl: 'https://calendly.com/patachara-psychotherapy/therapy-session',
    bio: [
      'Ms. Patachara (she/her) is an RCI-licensed clinical psychologist with around four years of experience working with a multidisciplinary team. She completed her undergraduate and postgraduate training at Fergusson College, Pune, and her MPhil in Clinical Psychology from NIMHANS, Bengaluru. She has research experience in the child and adolescent domain, along with two years of experience in training and capacity building for suicide prevention. She has a particular interest in trauma and the impact of adverse childhood experiences on individuals.',
      'She practices from LGBTQIA+ affirmative and Dalit–Bahujan–Adivasi (DBA) affirmative perspectives, with a strong focus on socio-cultural context, power, and lived experience. She aims to ensure that therapy is inclusive, culturally responsive, and grounded in a formulation that takes these factors into account.',
      'She works with people of all ages—individuals, couples, and families. She helps with a range of concerns like feeling low or anxious, getting stuck in repeated thoughts or habits, feeling overwhelmed by stress, struggling with long-standing emotional or relationship patterns, or dealing with addictions.',
      'In therapy, she adapts based on what each person needs. She keeps in mind how past experiences can affect present feelings and behaviour, and helps people understand and work through their emotions. She supports clients in identifying and changing deeper patterns, becoming more aware and present with their thoughts and feelings, and learning practical skills to manage intense emotions, cope with stress, and improve relationships. When working with couples, she focuses on helping them understand each other better and strengthen their emotional connection, and with families, she works on improving communication and overall relationship dynamics.',
      'Languages: English, Hindi, Marathi',
    ],
  },
  {
    photo: '/doctors/apurva.jpg',
    avatarClass: 'd4',
    name: 'Ms. Apurva',
    spec: 'Clinical Psychology',
    exp: '3 years experience',
    tags: ['Schema Therapy', 'CBT', 'Couple & Family'],
    comingSoon: true,
    bio: [
      'Ms. Apurva is a clinical psychologist with an M.Phil in Clinical Psychology from the National Institute of Mental Health and Neuro Sciences (NIMHANS), an Institute of National Importance. She currently works as an Assistant Professor in Kanpur and is available for online sessions.',
      'Her therapeutic practice is empathetic, collaborative, and individualized, with experience working with individuals, couples, families, children, and adolescents across a range of psychological and interpersonal concerns.',
      'She follows an eclectic and integrative approach, drawing primarily from Schema Therapy, Cognitive Behavioral Therapy (CBT), Interpersonal Therapy, and psychodynamic approaches. Schema Therapy is an important component of her practice, particularly in understanding longstanding patterns in thoughts, emotions, behaviours, and relationships that may have developed through early experiences and continue to affect present functioning.',
      'She also focuses on the therapeutic process and relational patterns that emerge within and beyond therapy. In couple and family work, she explores communication patterns, emotional needs, attachment dynamics, and recurring relational cycles, with the aim of fostering healthier and more meaningful ways of relating.',
      'She strives to provide a safe, authentic, and non-judgmental space where clients can understand themselves better, work through difficulties, and create meaningful, lasting change.',
    ],
  },
  {
    photo: '/doctors/divyata.jpg',
    avatarClass: 'd3',
    name: 'Dr. Divyata',
    spec: 'Psychiatry & Neuromodulation',
    exp: '5+ years experience',
    tags: ['Depression', 'Anxiety'],
    comingSoon: true,
    bio: [
      'Dr. Divyata is a psychiatrist with over five years of experience in mental healthcare. She completed her MD in Psychiatry and a Postdoctoral Fellowship in Non-Invasive Brain Stimulation at the National Institute of Mental Health and Neurosciences (NIMHANS), Bengaluru—India’s premier institution for mental health and neurosciences. She has also served as a Senior Resident in the Department of Psychiatry at AIIMS Nagpur.',
      'She works with individuals experiencing a wide range of mental health concerns, including depression, anxiety disorders, OCD, ADHD, addiction, schizophrenia, bipolar disorder, and sexual health disorders. Her approach is warm, collaborative, and patient-centered, focusing on understanding each person’s unique experiences and tailoring treatment plans to their individual needs, goals, and preferences.',
      'Dr. Divyata has a particular interest in neuromodulation therapies and has extensive experience in advanced treatments such as Transcranial Magnetic Stimulation (TMS), Transcranial Direct Current Stimulation (tDCS), Electroconvulsive Therapy (ECT), and ketamine therapy. She has independently administered more than 5,000 rTMS sessions and over 600 tDCS sessions, always emphasizing safety, ethics, and evidence-based care.',
      'She believes that effective mental healthcare goes beyond symptom management. By integrating medication, psychotherapy, family-based interventions, lifestyle modifications, and neuromodulation when appropriate, she strives to provide comprehensive and holistic care. Her goal is to create a safe, compassionate, and non-judgmental space where individuals feel heard, understood, and empowered to take meaningful steps toward recovery and well-being.',
    ],
  }
];

const Doctors = () => {
  const sectionRef = useRef(null);
  const [activeDoctor, setActiveDoctor] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-up');
    elements?.forEach((el) => observer.observe(el));
    return () => elements?.forEach((el) => observer.unobserve(el));
  }, []);

  useEffect(() => {
    if (!activeDoctor) return;
    const onKeyDown = (e) => { if (e.key === 'Escape') setActiveDoctor(null); };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [activeDoctor]);

  return (
    <section className="doctors-section" id="doctors" ref={sectionRef}>
      <div className="container">
        <div className="section-header fade-up">
          <span className="section-tag">Our team</span>
          <h2>Meet your care team</h2>
          <p>Experienced, empathetic professionals who truly listen</p>
        </div>

        <div className="doctors-grid fade-up">
          {doctorsData.map((doc, i) => (
            <div className="doctor-card" key={i}>
              <button
                className="doctor-profile-arrow"
                aria-label={`View full profile for ${doc.name}`}
                onClick={() => setActiveDoctor(doc)}
              >
                <ArrowUpRightIcon size={14} />
              </button>
              <div className={`doctor-avatar ${doc.avatarClass}`}>
                {doc.photo
                  ? <img src={doc.photo} alt={doc.name} />
                  : doc.initials}
              </div>
              <h3>{doc.name}</h3>
              <div className="doctor-spec">{doc.spec}</div>
              <div className="doctor-exp">{doc.exp}</div>
              <div className="doctor-tags">
                {doc.tags.map((tag, j) => (
                  <span className="doctor-tag" key={j}>{tag}</span>
                ))}
              </div>
              {doc.comingSoon ? (
                <button className="doctor-book doctor-book-soon" disabled>
                  Joining Soon
                </button>
              ) : (
                <button className="doctor-book" onClick={() => window.open(doc.bookingUrl, '_blank', 'noopener,noreferrer')}>
                  Connect Now
                </button>
              )}
            </div>
          ))}

          <div className="doctor-card doctor-card-cta">
            <div className="doctor-cta-icon">
              <HeartIcon size={26} color="currentColor" />
            </div>
            <h3>Not sure who's the right fit?</h3>
            <p className="doctor-cta-text">
              First time reaching out is the hardest step. Book a free 15-minute call — we'll listen, and help you find the support best suited for you.
            </p>
            <button
              className="doctor-cta-btn"
              onClick={() => window.open('https://book.healthplix.com/dr-doctor-s-name-specialisation-place-city_198213', '_blank', 'noopener,noreferrer')}
            >
              Book a free call <ArrowUpRightIcon size={14} />
            </button>
          </div>
        </div>
      </div>

      {activeDoctor && (
        <div className="doctor-modal-overlay" onClick={() => setActiveDoctor(null)}>
          <div className="doctor-modal" onClick={(e) => e.stopPropagation()}>
            <button className="doctor-modal-close" aria-label="Close" onClick={() => setActiveDoctor(null)}>×</button>
            <div className="doctor-modal-header">
              <div className={`doctor-avatar ${activeDoctor.avatarClass}`}>
                {activeDoctor.photo
                  ? <img src={activeDoctor.photo} alt={activeDoctor.name} />
                  : activeDoctor.initials}
              </div>
              <div>
                <h3>{activeDoctor.name}</h3>
                <div className="doctor-spec">{activeDoctor.spec}</div>
                <div className="doctor-exp">{activeDoctor.exp}</div>
              </div>
            </div>
            <div className="doctor-tags">
              {activeDoctor.tags.map((tag, j) => (
                <span className="doctor-tag" key={j}>{tag}</span>
              ))}
            </div>
            <div className="doctor-modal-bio">
              {activeDoctor.bio
                ? activeDoctor.bio.map((para, k) => <p key={k}>{para}</p>)
                : <p>Full profile coming soon.</p>}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Doctors;
